//@flow
export default {
  ADD_ITEM_TO_CART: 'addItemToCart',
  UPDATE_CART_ITEM: 'updateCartItem',
  DELETE_CART_ITEM: 'deleteCartItem',
  SIGN_UP: 'signUp',
  SIGN_UP_SUCCESS: 'signUpSuccess',
  SIGN_IN: 'signIn',
  SIGN_IN_SUCCESS: 'signInSuccess',
  CHECKOUT_STEP_ONE: 'checkoutStepOne',
  CHECKOUT_STEP_TWO: 'checkoutStepTwo',
  CHECKOUT_STEP_THREE: 'checkoutStepThree',
  ORDER_SUCCESS: 'orderSuccess',
  ORDER_ERROR: 'orderError',
  CART_TO_CHECKOUT: 'cartToCheckout',
  CANCEL_SURVEY: 'cancelSurvey',
  API_ERROR: 'apiError',
  SCROLL_DEPTH: 'scrollDepth',
  NOTIFICATION_DISPLAYED: 'notificationDisplayed',
  MODAL_DISPLAYED: 'modalDisplayed',
  ACTIVATE_PAYMENT_REQUEST: 'activatePaymentRequest',
  PAYMENT_REQUEST_SUCCESS: 'paymentRequestSuccess',
  SUBMIT_OFFICE_FORM: 'submitOfficeForm',
  QUOTE_UPDATED: 'quoteUpdated',
};
